<elo-header [toggled]="toggled"
            (onClickToToggled)="onClickToggled()"
            [headerTitle]="headerTitle"
            [brasaoByteArray]="brasaoByteArray"
            [headerSubtitle]="headerSubtitle"
            visibleUser="true"
            visibleAcessibilidade="true"
            [visibleNotifications]="false"
            flex="true"
            imgModule="img/modules/recursoshumanos-invertido-portalservidor.png"
            imgModuleMain="img/modules/recursoshumanos-invertido.png"
            imgModuleRebranding="img/modules/oxy-rh.svg"
            nameModule="Portal do Servidor"
            defaultHeaderClickFeature="user"
            fancy="true">
</elo-header>

<elo-features-group *ngIf="showFeaturesGroup"
                    (logout)="onLogout()"
                    [showMinhaConta]="false"
                    [showNovidadesVersao]="true"
                    [urlNovidades]="urlNovidades"
                    [getUsuarioLogado]="usuarioLogado"
                    [renderParametros]="false">
</elo-features-group>


<elo-spinner></elo-spinner>
<elo-notification></elo-notification>
<exception-handler></exception-handler>

<div *ngIf="!userRolesLoading && !isCpfFuncionario"
     class="not-found"
     style="max-width: 100%; height: calc(100vh - 210px); display: flex; flex-direction: column; align-items: center; justify-content: center;">
  <h1>
    <span class="fa fa-exclamation-circle"></span>
  </h1>
  <h2>Não conseguimos localizar servidores <br><br>para o CPF logado: {{ cpfCnpjFormatado }}</h2>
</div>

<div *ngIf="!userRolesLoading && isCpfFuncionario">
  <elo-sidebar #eloSideBar
               [toggled]="toggled"
               title="Portal do Servidor"
               imgModuleMain="img/modules/recursoshumanos.png"
               imgModule="img/modules/recursoshumanos-folhapagamento.png"
               fancy="true"
               [usuarioLogado]="usuarioLogado"
               (onInit)="onInitSideBar($event)"
               (onOpenSubMenu)="openSideBar()"
               [floatType]="toggled"
               (onHideRequest)="onSideBarHideRequest()"
               (onClickToToggled)="onClickToggled()">

    <div sidebaritem name="Início" route="home" icon="fa fa-home"></div>
    <div sidebaritem name="Licença Prêmio" route="licenca-premio" icon="fa fa-plane"></div>
    <div sidebaritem name="Permissão Negada" route="forbidden" icon="fa fa-home" [hidden]="true"></div>

    <ng-container *ngIf="habilitarExibicaoAvaliacao | async">
    <div sidebaritem name="Avaliações Funcionais" icon="fa fa-pencil">
      <div sidebaritem name="Avaliações Pendentes" route="avaliacoes/pendentes" icon="fa fa-pencil-square-o"></div>
      <div sidebaritem name="Avaliações Pessoais" route="avaliacoes/pessoais" icon="fa fa-user-o"></div>
      <div sidebaritem name="Avaliações Finalizadas" route="avaliacoes/finalizadas" icon="fa fa-check-square-o"></div>
    </div>
    </ng-container>

    <ng-container *ngIf="(habilitarExibicaoCat | async) && !isBloqueadoProducaoDiferenteHomologacao">
      <div sidebaritem name="Comun. Acidente Trabalho" icon="fa fa-ambulance iconmoon">
        <div sidebaritem name="Comun. Acidente Trabalho" route="comunicado-acidente-trabalho" icon="fa fa-pencil-square-o"></div>
      </div>
    </ng-container>

    <ng-container *ngIf="(habilitarExibicaoPrev | async)">
      <div sidebaritem name="Previdenciárias" icon="fa fa-book iconmoon">
        <div sidebaritem name="Consulta de Contribuição Previdenciária" route="consulta-contribuicao-previdenciaria" icon="fa fa-book"></div>
      </div>
    </ng-container>

    <ng-container *ngIf="(habilitarExibicaoRelatorios | async) && !isBloqueadoProducaoDiferenteHomologacao">
      <div sidebaritem name="Relatórios" route="relatorios" icon="fa fa-file-text-o"></div>
    </ng-container>

    <ng-container *ngIf="!isBloqueadoProducaoDiferenteHomologacao">
      <div sidebaritem name="Turmas Disponíveis" route="turmas-disponiveis" icon="fa fa-calendar iconmoon"></div>
    </ng-container>
  </elo-sidebar>

  <main-section [toggled]="toggled" [enabledBreadcrumb]="true"
                [urlsToLabels]="urlsToLabels">
    <div class="content-wrapper">
      <router-outlet></router-outlet>
    </div>
  </main-section>
  <rh-servidor-sidebar [menuPrincipal]="eloSideBar"
                       (idEntidadeSelecionada)="setEntidadeHeader($event)"></rh-servidor-sidebar>
</div>
